// AfterGlow – small progressive enhancements
(function () {
  'use strict';

  // Variant picker: keep the price and availability in sync with the chosen variant.
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var select = form.querySelector('[data-variant-select]');
    var price = document.querySelector('[data-product-price]');
    var button = form.querySelector('[data-add-to-cart]');
    if (!select) return;

    function update() {
      var option = select.options[select.selectedIndex];
      var available = option.getAttribute('data-available') === 'true';
      var idInput = form.querySelector('input[name="id"]');
      if (idInput) idInput.value = option.value;
      if (button) {
        button.disabled = !available;
        button.textContent = available ? button.getAttribute('data-label') : button.getAttribute('data-sold-out');
      }
      if (price) price.innerHTML = option.getAttribute('data-price');
    }

    select.addEventListener('change', update);
    update();
  });
})();

// Cart: the +/- steppers and quantity inputs save straight away and refresh the bag in place.
(function () {
  'use strict';

  if (!document.querySelector('.cart')) return;

  var pending = 0;            // save requests queued or running
  var chain = Promise.resolve();
  var needsRefresh = false;   // a save was sent, so the bag must be re-rendered
  var cartError = '';         // last stock/server error; stays until a save succeeds
  var saved = {};             // quantities the server confirmed since the last refresh

  function findInput(key) {
    var input = null;
    document.querySelectorAll('.cart [data-cart-key]').forEach(function (row) {
      if (row.getAttribute('data-cart-key') === key) input = row.querySelector('[data-qty-input]');
    });
    return input;
  }

  function setBusy(on) {
    var cart = document.querySelector('.cart');
    if (cart) cart.setAttribute('aria-busy', on ? 'true' : 'false');
  }

  // Re-render the bag from the server so prices, totals and the header count are exact.
  function refreshBag() {
    var focusTarget = null;
    var active = document.activeElement;
    if (active && active.closest && active.hasAttribute('data-focus')) {
      var activeRow = active.closest('[data-cart-key]');
      if (activeRow) focusTarget = { key: activeRow.getAttribute('data-cart-key'), focus: active.getAttribute('data-focus') };
    }

    return fetch('/cart', { headers: { Accept: 'text/html' } })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var oldCart = document.querySelector('.cart');
        var newCart = doc.querySelector('.cart');
        var oldActions = document.querySelector('.site-actions');
        var newActions = doc.querySelector('.site-actions');
        if (!oldCart || !newCart) { window.location.reload(); return; }

        oldCart.replaceWith(newCart);
        if (oldActions && newActions) oldActions.replaceWith(newActions);

        var errorEl = document.querySelector('[data-cart-error]');
        if (errorEl) errorEl.textContent = cartError;
        saved = {};

        // Keep keyboard focus on the same control after the swap.
        if (focusTarget) {
          var rows = document.querySelectorAll('.cart [data-cart-key]');
          for (var i = 0; i < rows.length; i++) {
            if (rows[i].getAttribute('data-cart-key') === focusTarget.key) {
              var el = rows[i].querySelector('[data-focus="' + focusTarget.focus + '"]');
              if (el && !el.disabled) el.focus();
              break;
            }
          }
        }
      })
      .catch(function () { window.location.reload(); });
  }

  // Queue a save for one line. Each request reads the input when it is sent,
  // so clicks made while an earlier request is running are not lost.
  function saveLine(key) {
    pending++;
    setBusy(true);
    chain = chain.then(function () {
      var input = findInput(key);
      if (!input) return;
      var quantity = Math.max(0, parseInt(input.value, 10) || 0);
      var confirmed = saved.hasOwnProperty(key) ? saved[key] : parseInt(input.defaultValue, 10);
      if (quantity === confirmed) return; // nothing new to save
      needsRefresh = true;
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      }).then(function (res) {
        if (res.ok) { saved[key] = quantity; cartError = ''; return; }
        return res.json().then(function (data) {
          cartError = data.description || 'Sorry, we could not update your bag.';
        });
      });
    }).catch(function () {
      needsRefresh = true;
      cartError = 'Sorry, we could not update your bag. Please try again.';
    }).then(function () {
      pending--;
      if (pending > 0) return;
      if (needsRefresh) {
        needsRefresh = false;
        return refreshBag();
      }
      setBusy(false);
    });
  }

  // +, − and Remove buttons.
  document.addEventListener('click', function (event) {
    var button = event.target.closest ? event.target.closest('[data-qty-step], [data-qty-remove]') : null;
    if (!button || !button.closest('.cart')) return;
    var row = button.closest('[data-cart-key]');
    var input = row && row.querySelector('[data-qty-input]');
    if (!input) return;

    var before = input.value;
    if (button.hasAttribute('data-qty-remove')) {
      input.value = 0;
    } else {
      var step = parseInt(button.getAttribute('data-qty-step'), 10);
      input.value = Math.max(1, (parseInt(input.value, 10) || 0) + step);
    }
    if (input.value !== before) saveLine(row.getAttribute('data-cart-key'));
  });

  // Typed quantities save when the field loses focus.
  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input.matches || !input.matches('[data-qty-input]')) return;
    var row = input.closest('[data-cart-key]');
    input.value = Math.max(0, parseInt(input.value, 10) || 0);
    saveLine(row.getAttribute('data-cart-key'));
  });

  // Enter in a quantity field saves it, and stops the form from submitting to checkout.
  document.addEventListener('keydown', function (event) {
    var input = event.target;
    if (event.key !== 'Enter' || !input.matches || !input.matches('[data-qty-input]')) return;
    event.preventDefault();
    if (input.value !== input.defaultValue) input.dispatchEvent(new Event('change', { bubbles: true }));
  });
})();


// Glossy lava transition when moving to the home page or a collection
(function () {
  'use strict';
  var wipe = document.querySelector('.lava-wipe');
  if (!wipe) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function isTransitionLink(a) {
    if (a.target && a.target !== '_self') return false;
    if (a.hasAttribute('download')) return false;
    var url;
    try { url = new URL(a.href, window.location.href); } catch (e) { return false; }
    if (url.origin !== window.location.origin) return false;
    if (url.pathname === window.location.pathname && url.hash) return false;
    if (a.hasAttribute('data-lava')) return true;
    return url.pathname === '/' || url.pathname.indexOf('/collections/') === 0;
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || !isTransitionLink(a)) return;

    if (reduce) return; // let the normal navigation happen

    e.preventDefault();
    var href = a.href;
    wipe.classList.add('is-active');
    setTimeout(function () { window.location.href = href; }, 800);
  });

  // Coming back with the Back button: clear the overlay
  window.addEventListener('pageshow', function () {
    wipe.classList.remove('is-active');
  });
})();
